module.exports = __webpack_public_path__ + "img/visual-studio-code.de4f38c6.svg";